URL = '/keepcon/settings/account_setting/conversation_attribute_definitions'
class AccountSettings.ConversationAttribute extends Backbone.Model
  urlRoot: URL

  save: (attrs, options) ->
    attrs ||= _.clone(this.attributes)
    options ||= {}
    data = {'conversation_attribute_definition': attrs}
    super data, options

  isFixedString: =>
    @get('attribute_type_name') == 'FixedString'

  isHierarchicalTags: =>
    @get('attribute_type_name') == 'HierarchicalTags'

  getHierarchicalTagCollection: ->
    new AccountSettings.ConversationAttributes.HierarchicalTagCollection(
      @get('hierarchical_tags').tags
    )

  toggleVisibility: (options) ->
    $.ajax
      url: "#{@urlRoot}/#{@id}/toggle_visibility"
      type: 'PUT'
      success: options.success
      error: options.error


class AccountSettings.ConversationAttributeCollection extends Backbone.Collection
  model: AccountSettings.ConversationAttribute
  url: URL

  parse: (response) ->
    @availableTypes = response.available_types
    @readonlyFields = response.readonly_fields
    super(response.conversation_attribute_definitions)

  updatePositions: (originalPosition, newPosition) ->
    return this if originalPosition == newPosition
    temp = @at(originalPosition)
    @remove(temp, { silent: true })
    @add(temp, { at: newPosition, silent: true })
    return Backbone.ajax({
      url: @url + '/sort',
      method: 'POST',
      data: { ids: @pluck('id') },
      dataType: "json",
    });
